import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { lastValueFrom } from 'rxjs';
import { SharedProfileService } from 'src/app/components/profile/shared-profile.service';
import { InOutAnimation } from 'src/app/shared/animations/animations';
import { AnimatedLoaderType } from 'src/app/shared/models/animated-loader-type.enum';
import { AuthenticationService } from 'src/app/shared/services';
import { AppwriteService } from 'src/app/shared/services/appwrite.sdk.service';
import { selectIsWebhookComplete } from 'src/app/shared/store/_features/user/auth/auth.selectors';
//
import {
  AccountSetupHelperService,
  OnboardingWizardSetupStepsEnum,
} from './account-setup-helper.service';

export class OnboardingWizardSetupStep {
  enum: OnboardingWizardSetupStepsEnum;
  actionButtons?: {
    next: {
      disabled: boolean;
      label: string;
    };
    skip: {
      disabled: boolean;
      label: string;
    };
    back: {
      disabled: boolean;
      label: string;
    };
  };
}

@Component({
  selector: 'app-account-setup-wizard',
  templateUrl: './account-setup-wizard.component.html',
  styleUrls: ['./account-setup-wizard.component.css'],
  animations: [InOutAnimation],
})
export class AccountSetupWizardComponent implements OnInit {
  animatedLoaderType = AnimatedLoaderType;

  processing: boolean = false;

  isWebhookDone: boolean = false;
  onboardingWizardSetupStepsEnum = OnboardingWizardSetupStepsEnum;

  constructor(
    public sharedProfileService: SharedProfileService,
    private authService: AuthenticationService,
    private toastr: ToastrService,
    private store: Store,
    public accountSetupHelperService: AccountSetupHelperService,
  ) {
    this.accountSetupHelperService.initializeWizardProductCreate();
    this.store.select(selectIsWebhookComplete).subscribe((value) => {
      this.isWebhookDone = value;
    });
  }

  submit() {}
  onClickNext() {
    this.submit();
    this.nextStep();
    console.log(this.accountSetupHelperService.wizardData);
  }

  onClickBack() {
    this.accountSetupHelperService.wizardModel.goToPreviousStep();
  }

  nextStep() {
    this.setProcessing(true);
    setTimeout(() => {
      this.accountSetupHelperService.wizardModel.goToNextStep();

      setTimeout(() => {
        this.setProcessing(false);
      }, 2500);
    }, 500);
  }

  async finalStep() {
    this.setProcessing(true);
    setTimeout(async () => {
      await this.onSkip();
      this.setProcessing(false);
    }, 500);
  }

  setProcessing(value: boolean) {
    if (value) {
      this.accountSetupHelperService.setAiLoaderState('writing');
    } else {
      this.accountSetupHelperService.setAiLoaderState('idle');
    }
    this.processing = value;
  }

  async onSkip() {
    this.authService.markWebsiteOnboardingAsDone();
  }

  async ngOnInit() {
    this.isWebhookDone = await this.authService.isWebhookDone();
  }
}
